export type HttpMethod =
  | 'GET'
  | 'HEAD'
  | 'POST'
  | 'PUT'
  | 'PATCH'
  | 'OPTIONS'
  | 'DELETE';

export class HTTPError extends Error {
  status: number;
  url: string;

  constructor(public response: Response) {
    super(response.statusText);

    this.name = 'HTTPError';
    this.status = response.status;
    this.url = response.url;
  }
}
